export default __webpack_public_path__ + "707e2d0d5cf64dcd552975fe2073147b.svg";